import http from 'services/http';

// Mirrors the JobProcess statuses the backend serializes/broadcasts. The UI maps pending|running
// -> processing, completed -> success, error -> failure.
export type DenialListImportStatus = 'pending' | 'running' | 'completed' | 'error';

export interface DenialListImport {
  id: string;
  status: DenialListImportStatus;
  // Human-readable failure message (PHI-free), shown on the failure toast.
  error: string | null;
  filename: string | null;
}

export interface CreateDenialListImportParams {
  clientId: string;
  signedId: string;
  filename: string;
}

export async function createDenialListImport(params: CreateDenialListImportParams): Promise<DenialListImport> {
  return http.post<DenialListImport>('/admin/denial_list_imports', params).then((response) => response.data);
}

export function isTerminalImportStatus(status: DenialListImportStatus): boolean {
  return status === 'completed' || status === 'error';
}
